// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import srTranslations from './locales/sr.json';

// Get the user's preferred language from localStorage or use browser language
const getUserLanguage = () => {
  const storedLanguage = localStorage.getItem('userLanguage');

  if (storedLanguage) {
    return storedLanguage;
  }

  // Try to detect browser language, falling back to Serbian
  const browserLanguage = navigator.language.split('-')[0];
  return browserLanguage === 'en' || browserLanguage === 'sr'
    ? browserLanguage
    : 'sr';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    sr: { translation: srTranslations },
  },
  lng: getUserLanguage(), // Use detected or stored language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  // Additional options for better performance and user experience
  detection: {
    order: ['localStorage', 'navigator'],
  },
});

export default i18n;
